












































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem, SkeletonBox } from '@/layouts/components'

import { Item } from '@/models'

import ItemImage from './ItemImage.vue'

@Component({
  components: {
    ItemImage,
    ListItem,
    SkeletonBox
  }
})
export default class ItemTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Item

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  isLoadingImage = true
}
